import { render, staticRenderFns } from "./CurrentlyOnTable.vue?vue&type=template&id=40a05dbf&scoped=true&"
import script from "./CurrentlyOnTable.vue?vue&type=script&lang=js&"
export * from "./CurrentlyOnTable.vue?vue&type=script&lang=js&"
import style0 from "./CurrentlyOnTable.vue?vue&type=style&index=0&id=40a05dbf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a05dbf",
  null
  
)

export default component.exports